import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Popover} from 'shells/popover/popover';
import {Body} from 'shells/typography/body';

import type {CompetitorForLeadFragment as Competitor} from 'nutshell-graphql-types';

import {ReportUrl} from '../../components/report-url';

type Props = {
    anchor: HTMLElement | null | undefined;
    competitor: Competitor;
    onClose: () => void;
};

export function CompetitorPopover(props: Props) {
    if (!props.anchor) return null;

    const winRate =
        typeof props.competitor.leadSuccessPercent === 'number'
            ? props.competitor.leadSuccessPercent
            : null;

    return (
        <Popover
            anchor={props.anchor}
            onBlur={props.onClose}
            customStyles={{maxWidth: '280px', padding: '16px'}}
            disableFocusTrapZone={true}
        >
            <Stack spacing={20}>
                <Body size='large' color='dark' isBold={true}>
                    {props.competitor.name}
                </Body>
                <Stack spacing={12}>
                    {winRate !== null ? (
                        <Body size='small'>
                            <Body isBold={true} size='small'>
                                {String(winRate)}%
                            </Body>{' '}
                            win rate on leads against {props.competitor.name}
                        </Body>
                    ) : (
                        <Body size='small'>
                            No closed leads against {props.competitor.name} yet
                        </Body>
                    )}
                    {props.competitor.reportUrl && (
                        <ReportUrl
                            url={props.competitor.reportUrl}
                            name={props.competitor.name || ''}
                        />
                    )}
                </Stack>
            </Stack>
        </Popover>
    );
}
